import type {ReactElement} from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {assertNever} from '@Utils/assert-never.util';
import {SAVE_STATUS_TOOLTIP_HIDE_DELAY_MS, SAVE_STATUS_TOOLTIP_ID, SAVE_STATUS_TOOLTIP_SHOW_DELAY_MS, SaveStatusBadgeVariant} from './save-status-badge.types';
import type {SaveStatusBadgeProps} from './save-status-badge.types';
import styles from './save-status-badge.module.scss';

export function SaveStatusBadge({label, icon, tooltipText, variant = SaveStatusBadgeVariant.DEFAULT}: SaveStatusBadgeProps): ReactElement {
  const badge = (
    <span className={`${styles.badge} ${resolveVariantClass(variant)}`}>
      <span className={styles.iconWrap}>
        <Icon aria-hidden icon={icon} type={IconType.NONE} shape={IconShape.SQUARE} size={IconSize.SIZE_ICON_16} />
      </span>
      <Text size={TextSize.SM} val={label} className={styles.label} />
    </span>
  );
  if (tooltipText === undefined) {
    return badge;
  }
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="bottom"
      delay={{show: SAVE_STATUS_TOOLTIP_SHOW_DELAY_MS, hide: SAVE_STATUS_TOOLTIP_HIDE_DELAY_MS}}
      overlay={
        <Tooltip id={SAVE_STATUS_TOOLTIP_ID} className={styles.tooltip}>
          <Text size={TextSize.SM} val={tooltipText} />
        </Tooltip>
      }
    >
      <span className={styles.badgeWrapper} tabIndex={0}>
        {badge}
      </span>
    </OverlayTrigger>
  );
}

function resolveVariantClass(variant: SaveStatusBadgeVariant): string {
  switch (variant) {
    case SaveStatusBadgeVariant.DISABLED:
      return styles.badgeDisabled;
    case SaveStatusBadgeVariant.SAVING:
    case SaveStatusBadgeVariant.DEFAULT:
      return '';
    default:
      return assertNever(variant);
  }
}
